import React, { FC, useEffect, useState } from "react";
import { TimePicker, TimePickerProps } from "antd";
import { Maybe } from "graphql/jsutils/Maybe";
import { Core_LocalTimeMsg } from "../../../../src/generated/graphql";
import { Moment } from "moment";
import {
  localTimeToMoment,
  momentToLocalTime,
} from "../../../../helpers/utils";

interface LocalDateInputProps {
  value: Maybe<Core_LocalTimeMsg> | undefined;
  onChange: (value: Maybe<Core_LocalTimeMsg> | undefined) => void;
}

export const LocalTimeInput: FC<LocalDateInputProps> = ({
  value,
  onChange,
}) => {
  const [internalValue, setInternalValue] = useState<
    Maybe<Moment> | undefined
  >();

  useEffect(() => {
    const momentOfLocalDate = localTimeToMoment(value);
    // TODO check if times are the same. Whats the granularity?
    setInternalValue(momentOfLocalDate);
  }, [value]);

  const onTimeChange: TimePickerProps["onChange"] = (time) => {
    setInternalValue(time);

    onChange(momentToLocalTime(time));
  };

  return (
    <div>
      <TimePicker
        size={"large"}
        style={{ width: "100%" }}
        value={internalValue}
        onChange={onTimeChange}
      />
    </div>
  );
};
